import { jsx as _jsx } from "react/jsx-runtime";
import Image from "next/image";
import src from "./three-birds-flying-video.png";
export const ThreeBirdsFlyingVideo = ()=>/*#__PURE__*/ _jsx(Image, {
        src: src,
        alt: "Drop here to upload",
        className: "block size-40",
        width: 160,
        height: 160
    });
